var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"ifr__dementia",attrs:{"id":"app"}},[_c('Intro'),_c('MapData'),_c('Signals'),_c('Stories'),_c('Risk'),_c('Social')],1)}
var staticRenderFns = []

export { render, staticRenderFns }